import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { SupplierBillService, Justification, ChargeNote, SupplierBill, SupplierBillId } from '../../services/supplier-bill.service';
import { PurchaseOrderService } from '../../services/purchase-order.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { Upload } from '../../services/upload/upload';
import { ExpenseConceptService, ExpenseConcept } from '../../services/expense-concept.service';
import { CustomerBillData } from '../../services/customer-bill.service';

@Component({
  selector: 'app-display-supplier-bill',
  templateUrl: './display-supplier-bill.component.html',
  styleUrls: ['./display-supplier-bill.component.css']
})
export class DisplaySupplierBillComponent implements OnInit, OnDestroy {

  supplierBillId: string;
  supplierBill: SupplierBillId;
  supplierBillSub;

  supplierBillForm: FormGroup;

  purchaseOrders = {};
  purchaseOrderSub;

  constructor(
    private service: SupplierBillService,
    private purchaseOrderService: PurchaseOrderService,
    private expenseConceptService: ExpenseConceptService,
    private billData: CustomerBillData,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.supplierBillId = this.activatedRoute.snapshot.paramMap.get('id');

    let expenseConceptSub = this.expenseConceptService.getExpenseConcepts().subscribe(concepts => {
      expenseConceptSub.unsubscribe();
      for(let concept of concepts) this.expenseConcepts[concept.id] = concept;
    });

    this.justifications = [];
    this.purchaseOrders = {};
    this.purchaseOrderSub = this.purchaseOrderService.getPurchaseOrders().subscribe(purchaseOrders => {
      purchaseOrders.map(purchaseOrder => {
        this.purchaseOrders[purchaseOrder.id] = {...purchaseOrder};
      });
    });
  }

  ngOnInit() {
    this.createForm();
    this.supplierBillSub = this.service.getSupplierBill(this.supplierBillId).subscribe(([doc]: SupplierBillId[]) => {
      let {currency='key0', change=1, ...supplierBill} = doc;
      let currencyName = this.billData.currencySelect[currency].full
      this.supplierBill = {currency, change, ...supplierBill};
      this.supplierBillForm.patchValue({...this.supplierBill, currency: currencyName});
      this.justifications = supplierBill.justifications;
      this.chargeNotes = supplierBill.chargeNotes;
    })
  }

  createForm(){
    this.supplierBillForm = this.fb.group({
      folio: ['', Validators.required],
      date: ['', Validators.required],
      subtotal: ['', [Validators.required, Validators.min(0)]],
      iva: ['', [Validators.required, Validators.min(0)]],
      total: ['', [Validators.required, Validators.min(0)]],
      payDate: ['', [Validators.required]],
      retentionIVA: [0, Validators.required],
      retentionISR: [0, Validators.required],
      currency: ['', Validators.required],
      change: [1, Validators.required],
    });
  }

	ngOnDestroy() {
    this.purchaseOrderSub.unsubscribe();
    this.supplierBillSub.unsubscribe();
  }

  uploadFile(event) {
    var selectedFile: File = event.target.files[0];
    var currentUpload: Upload = new Upload(selectedFile);
    this.service.uploadFile(currentUpload, this.supplierBill, selectedFile.name);
  }

  deleteFile(index){
    this.service.deleteFile(this.supplierBill, index);
  }
  
  money = Utils.money;

  //////////////////////////////////////////////////////////////////////////////////////////////JUSTIFICATIONS
  justifications: Justification[];

  expenseConcepts: {[id: string]: ExpenseConcept} = {};
  
  get justificationsTotal(): number {
    return this.justifications.reduce((total, {price}) => total + price, 0);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////JUSTIFICATIONS

  //////////////////////////////////////////////////////////////////////////////////////////////CREDIT_NOTE
  chargeNotes: ChargeNote[] = [];
  get chargeNotesTotal(): number { return this.chargeNotes.reduce((acc,{total}) => acc + total, 0) }
  //////////////////////////////////////////////////////////////////////////////////////////////CREDIT_NOTE

}